import { baseApi } from '../axios';

export const getAllCourses = async () => {
	const response = await baseApi.get(`/course`);
	return response;
};

export const enrolInCourses = async (courses: string[]) => {
	console.log('courses ids:', courses);
	const response = await baseApi.post(`/enrollments`, { courses });
	return response;
};

export const getPublishedItems = async ({ courseId }: { courseId?: string }) => {
	if (!courseId) {
		return { data: { publishedItems: [] } };
	}
	const response = await baseApi.get(`/published-item/${courseId}/all`);
	return response;
};

export const getBlockItems = async ({ blockID, type }: { blockID?: string; type?: string }) => {
	let finalType = type?.toLowerCase();
	if (type === 'contest' || type === 'quiz') finalType = 'Assessment';
	if (type === 'resource') finalType = 'Resource';
	if (type === 'lecture') finalType = 'Lecture';

	const response = await baseApi.get(`/block/block-items/${blockID}?type=${finalType}`);
	return response;
};
// export const getPublishedItem = async ({ publishedItemId }: { publishedItemId?: string }) => {
// 	const response = await baseApi.get(`/published-item/${publishedItemId}`);

// 	return response;
// };
